import type fr from '../fr/admin';

const en: typeof fr = {
  nav: {
    home: 'Home',
    planning: 'Planning',
    map: 'Map',
    quotes: 'Quotes',
    clients: 'Clients',
    properties: 'Properties',
    employees: 'Employees',
    teams: 'Teams',
    payroll: 'Payroll',
    messages: 'Messages',
    finances: 'Finances',
    settings: 'Settings',
  },
  languageName: { fr: 'French', en: 'English' },
  search: { placeholder: 'Search a client, address, employee, #job…', empty: 'No results.', clients: 'Clients', properties: 'Properties', employees: 'Employees', jobs: 'Jobs', quotes: 'Quotes' },
};
export default en;
